import axios from "axios"
import {
  GET_ALL_BUSINESS__VIRTUAL_CARDS_FAIL,
  GET_ALL_BUSINESS__VIRTUAL_CARDS_REQUEST,
  GET_ALL_BUSINESS__VIRTUAL_CARDS_SUCCESS,
  GET_ALL_BUSINESS_FAIL,
  GET_ALL_BUSINESS_REQUEST,
  GET_ALL_BUSINESS_SUCCESS,
  GET_ALL_BUSINESS_TRANSACTIONS_FAIL,
  GET_ALL_BUSINESS_TRANSACTIONS_REQUEST,
  GET_ALL_BUSINESS_TRANSACTIONS_SUCCESS
} from "../constants/adminConstants"
import { BASE_API_URL } from "../constants/dropdown"
const PER_PAGE_SIZE = 200
export const fetchAllBusiness =
  (pageNumber, filterData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_ALL_BUSINESS_REQUEST
      })

      const {
        admin2faLogin: { userInfo }
      } = getState()
      const token = userInfo?.token?.access_token
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }

      const page = isNaN(pageNumber) ? 1 : pageNumber

      if (filterData === undefined) {
        console.log("here")
        const { data } = await axios.get(
          `${BASE_API_URL}/admin/business/all?page=${page}&size=${PER_PAGE_SIZE}`,
          config
        )
        console.log(data)
        dispatch({
          type: GET_ALL_BUSINESS_SUCCESS,
          payload: data
        })
      } else {
        const year = new Date().getFullYear()
        const date = new Date(year, 0, 1)
        const { endDate, businessemail, accountnumber } = filterData

        const startDate =
          filterData.startDate === undefined ? date : filterData.startDate

        if (businessemail) {
          const { data } = await axios.get(
            `${BASE_API_URL}/admin/business/all?businessemail=${businessemail}`,
            config
          )

          dispatch({
            type: GET_ALL_BUSINESS_SUCCESS,
            payload: data
          })
        } else if (accountnumber) {
          const { data } = await axios.get(
            `${BASE_API_URL}/admin/business/all?accountnumber=${accountnumber}`,
            config
          )

          dispatch({
            type: GET_ALL_BUSINESS_SUCCESS,
            payload: data
          })
        } else {
          const { data } = await axios.get(
            `${BASE_API_URL}/admin/business/all?page=${page}&size=${PER_PAGE_SIZE}`,
            config
          )

          dispatch({
            type: GET_ALL_BUSINESS_SUCCESS,
            payload: data
          })
        }
      }
    } catch (error) {
      console.log(error)
      dispatch({
        type: GET_ALL_BUSINESS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

export const fetchAllBusinessTransactions =
  (customerid, walletid, filterData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_ALL_BUSINESS_TRANSACTIONS_REQUEST
      })

      const {
        admin2faLogin: { userInfo }
      } = getState()
      const token = userInfo?.token?.access_token
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
      if (filterData === undefined) {
        const { data } = await axios.get(
          `${BASE_API_URL}/admin/business/transactions?size=${PER_PAGE_SIZE}&customerid=${customerid}&walletid=${walletid}`,
          config
        )
        dispatch({
          type: GET_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
          payload: data
        })
      } else {
        const { transactionreference, paymentReference } = filterData

        if (transactionreference) {
          const { data } = await axios.get(
            `${BASE_API_URL}/admin/business/transactions?customerid=${customerid}&walletid=${walletid}&transactionreference=${transactionreference}&size=${PER_PAGE_SIZE}`,
            config
          )
          dispatch({
            type: GET_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
            payload: data
          })
        } else if (paymentReference) {
          const { data } = await axios.get(
            `${BASE_API_URL}/admin/business/transactions?customerid=${customerid}&walletid=${walletid}&paymentreference=${paymentReference}&size=${PER_PAGE_SIZE}`,
            config
          )
          dispatch({
            type: GET_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
            payload: data
          })
        } else {
          const { data } = await axios.get(
            `${BASE_API_URL}/admin/business/transactions?customerid=${customerid}&walletid=${walletid}&size=${PER_PAGE_SIZE}`,
            config
          )
          dispatch({
            type: GET_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
            payload: data
          })
        }
      }
    } catch (error) {
      console.log(error)
      dispatch({
        type: GET_ALL_BUSINESS_TRANSACTIONS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

export const fetchAllBusinessVirtualCards =
  (businessId, customerId) => async (dispatch, getState) => {
    try {
      console.log("creating settings")
      dispatch({
        type: GET_ALL_BUSINESS__VIRTUAL_CARDS_REQUEST
      })

      const {
        admin2faLogin: { userInfo }
      } = getState()
      const token = userInfo?.token?.access_token
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }

      const { data } = await axios.get(
        `${BASE_API_URL}/admin/business/assigned-cards?businessId=${businessId}&customerId=${customerId}&size=${PER_PAGE_SIZE}`,
        config
      )
      dispatch({
        type: GET_ALL_BUSINESS__VIRTUAL_CARDS_SUCCESS,
        payload: data
      })
    } catch (error) {
      console.log(error)
      dispatch({
        type: GET_ALL_BUSINESS__VIRTUAL_CARDS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }
